export default {
  title: 'Pyydä tietojen poistoa – {{name}}',
  description:
    'Tämä luo GDPR-tietojenpoistopyynnön. Järjestelmänvalvojan on hyväksyttävä se, ennen kuin asiakkaan tiedot poistetaan pysyvästi.',
  form: {
    note: {
      label: 'Huomautus',
      placeholder: 'Lisää taustatietoa pyynnölle (valinnainen)',
    },
  },
  buttons: {
    confirm: 'Pyydä poistoa',
  },
  toasts: {
    success: 'Tietojenpoistopyyntö luotu',
    error: 'Tietojenpoistopyynnön luonti epäonnistui',
  },
};
